import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import {useRouter} from 'next/router';
import { useDispatch } from 'react-redux';
import { useVehicle } from '../../rcaSlice';
import { useVehicleStorage } from '../../../utils/compare/rcaForm';
import RCANextSteps from '../RCANextSteps';
import ErrorMessage from '../../../elements/ErrorMessage';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Badge from 'react-bootstrap/Badge';
import styles from '../../../styles/rca/RCACarInfo.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faChevronRight, faCar, faPen } from '@fortawesome/free-solid-svg-icons';
import { apiDataFromVehicle } from '../../../utils/compare/rcaForm';
import { carPlateNumber, VINMask } from '../../../utils/compare/rcaUtils';
import CarTabs from './CarTabs';
import FloatMessage from '../../../elements/FloatMessage';


const CarInfo = (props) => {

    const {vehicle, CSRFToken, editStep, vehiclesNumber, editCarInfo} = props;
    const dispatch= useDispatch();
    const router = useRouter();

    const isMounted = useRef(null);
    const [isLoadingPage, editIsLoadingPage] = useState(true);
    const [isError, editIsError] = useState(false);
    const [CSRFError, editCSRFError] = useState(false);
    const [disableBtn, editDisableBtn] = useState(false);

    useEffect ( ()=>{
        isMounted.current = true;
        checkCar();
        editIsLoadingPage(true);

        return ()=>{
            isMounted.current = false;
        }
    }, [])

    const nextSteps = ['Proprietar', 'Adresa', 'Conducatori auto'];
    const backToAutoList = () => { editStep('list')}

    const loadingScreen =  
        <div className="text-center w-100 py-3">
            <Spinner animation="border" variant="success" size="lg"  />
        </div>;

    const checkCar = async () =>{
        try {
            let fields = apiDataFromVehicle(vehicle);
            const apiData = fields;
            const url = process.env.NEXT_PUBLIC_API + '/api/insurance/rca/search/auto';
            const response = await axios({
                url,
                method: 'post',
                data: apiData,
                headers: {'Content-Type': 'application/json', CSRFToken},
                withCredentials: true,
            })
            const data = response.data;
    
            if (isMounted.current) {

                if (data.status == 'success') {
                  editIsLoadingPage(false);
                } else if (data.status == '400') {
                    editCSRFError('Sesiune expirată. Pagina se va reîncarca automat.');
                    // router.reload(window.location.pathname);
                    window.location.reload(false);
                } else {
                    editCarInfo();
                }
            }

        } catch(err){
            
            if (isMounted.current) {
                editIsLoadingPage(false);
                editIsError('Ooops, ceva nu funcționează corect.');
            }
        }
    }

    const pageReload = CSRFError &&
        <FloatMessage
            message={CSRFError}
        />;

    const registrationInfo = !isLoadingPage &&
        <Row className={styles.listInfo}>
            <Col xs={12} md={6} className={styles.label}>
                Categorie auto:
            </Col>
            <Col xs={12} md={6} className={styles.value}>
                {vehicle.car.subcategorie_auto.denumire}
            </Col>
            <Col xs={12} md={6} className={styles.label}>
                Stare înmatriculare
            </Col>
            <Col xs={12} md={6} className={styles.value}>
                {vehicle.car.tip_inmatriculare.label}
            </Col>
            { vehicle.car.tip_inmatriculare.value == 'inmatriculat' &&
            <>
                <Col xs={12} md={6} className={styles.label}>
                    Număr de înmatriculare
                </Col>
                <Col xs={12} md={6} className={styles.value}>
                    {carPlateNumber(vehicle.car.nr_inmatriculare)}
                </Col>
                <Col xs={12} md={6} className={styles.label}>
                    Dată înmatriculare
                </Col>
                <Col xs={12} md={6} className={styles.value}>
                    {vehicle.car.data_inmatriculare}
                </Col>
                <Col xs={12} md={6} className={styles.label}>
                    Dată expirare ITP
                </Col>
                <Col xs={12} md={6} className={styles.value}>
                    {vehicle.car.data_expirare_itp}
                </Col>
            </>
            }
            <Col xs={12} md={6} className={styles.label}>
                Serie șasiu
            </Col>
            <Col xs={12} md={6} className={styles.value}>
                {VINMask(vehicle.car.serie_sasiu)}
            </Col>
            <Col xs={12} md={6} className={styles.label}>
                Număr kilometri
            </Col>
            <Col xs={12} md={6} className={styles.value}>
                {vehicle.car.numar_km}
            </Col>
        </Row>
        ;

    const modelInfo = !isLoadingPage &&
        <Row className={styles.listInfo}>
            <Col xs={12} md={6} className={styles.label}>
                Marcă auto:
            </Col>
            <Col xs={12} md={6} className={styles.value}>
                {vehicle.car.marca_auto.denumire}
            </Col>
            <Col xs={12} md={6} className={styles.label}>
                Model:
            </Col>
            <Col xs={12} md={6} className={styles.value}>
                {vehicle.car.model_auto}
            </Col>
            <Col xs={12} md={6} className={styles.label}>
                Anul de fabricație
            </Col>
            <Col xs={12} md={6} className={styles.value}>
                {vehicle.car.an_fabricatie}
            </Col>
        </Row>;

    const tehnicalData = !isLoadingPage &&
        <Row className={styles.listInfo}>
            <Col xs={12} md={6} className={styles.label}>
                Capacitatea cilindrică
            </Col>
            <Col xs={12} md={6} className={styles.value}>
                {vehicle.car.capacitate_cilindrica} cmc
            </Col>
            <Col xs={12} md={6} className={styles.label}>
                Masa maximă
            </Col>
            <Col xs={12} md={6} className={styles.value}>
                {vehicle.car.masa_totala} kg
            </Col>
            <Col xs={12} md={6} className={styles.label}>
                Putere
            </Col>
            <Col xs={12} md={6} className={styles.value}>
                {vehicle.car.putere_kw} kW
            </Col>
            <Col xs={12} md={6} className={styles.label}>
                Combustibil
            </Col>
            <Col xs={12} md={6} className={styles.value}>
                {vehicle.car.combustibil.denumire}
            </Col>
            <Col xs={12} md={6} className={styles.label}>
                Seria cărții auto (CIV)
            </Col>
            <Col xs={12} md={6} className={styles.value}>
                {vehicle.car.civ}
            </Col>
        </Row>;

    const usageInfo = !isLoadingPage &&
        <Row className={styles.listInfo}>
            <Col xs={12} md={6} className={styles.label}>
                Leasing în derulare
            </Col>
            <Col xs={12} md={6} className={styles.value}>
                {vehicle.car.leasing}
            </Col>
            { vehicle.car.leasing == 'da' &&
                <>
                    <Col xs={12} md={6} className={styles.label}>
                        Societatea de leasing
                    </Col>
                    <Col xs={12} md={6} className={styles.value}>
                        {vehicle.car.leasing_company_id.nume}
                    </Col>
                </>
               
            }
             <Col xs={12} md={6} className={styles.label}>
                Utilizare în scop
            </Col>
            <Col xs={12} md={6} className={styles.value}>
                {vehicle.car.tip_utilizare}
            </Col>
        </Row>;

    
    const goToNextStep = () => { 
        editDisableBtn(true);
        dispatch(useVehicle({ serie_sasiu: vehicle.serie_sasiu, step: 'proprietar', status: 'save' }));
        router.push('asigurari-rca/proprietar');
    }

    return (
        <>
            { isLoadingPage ?
                loadingScreen
            :
            <>
            <CarTabs 
                vehiclesNumber={vehiclesNumber}
                backToAutoList={backToAutoList}
                activeTab={`${vehicle.car.marca_auto.denumire} ${vehicle.car.model_auto}`}
            />
            <section className={`${styles.boxWrapper} p-3 mb-3`}>
                {isError ?
                <div className="mt-3">
                    <ErrorMessage title="Eroare" message={isError} />
                </div> 
                :
                <>
                    
                    <div className="mb-1">
                        <Button className="red" variant="link" onClick={editCarInfo} >
                            <FontAwesomeIcon icon={faPen} height={16} width={16}  className="mr-2" />
                            Editează
                        </Button>
                    </div>
                   
                    <p className={`heading3 ${styles.section} mt-3 green`}>
                        Date de înmatriculare
                    </p>
                    {registrationInfo}
                    <p className={`heading3 ${styles.section} mt-3 green`}>
                        Model auto
                    </p>
                    {modelInfo}
                    <p className={`heading3 ${styles.section} mt-3 green`}>
                        Date tehnice
                    </p>
                    {tehnicalData}
                    <p className={`heading3 ${styles.section} mt-3 green`}>
                        Utilizare
                    </p>
                    {usageInfo}
                    <Col xs={12} md={6} className="mt-3 mt-lg-5 ">
                        <Button className="w-100" 
                            onClick={goToNextStep} 
                            disabled={disableBtn}
                        >
                            Continuă
                            <FontAwesomeIcon icon={faChevronRight} className="ml-2" height="16" width="16" />
                        </Button>
                       
                    </Col>
                    
                </>
                }
            </section>
                <RCANextSteps steps={nextSteps} />
               
            </>
            }
            {pageReload}

        </>
    );
}

export default CarInfo;